/* eslint-disable react-refresh/only-export-components */
import { INotification } from '@/types/type'
import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

export interface INotificationContext {
  newNotificationsArr: INotification[]
  setNewNotificationsArr: React.Dispatch<React.SetStateAction<INotification[]>>
}

const NotificationContext = createContext<INotificationContext | null>(null)

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [newNotificationsArr, setNewNotificationsArr] = useState([] as INotification[])

  const value = useMemo(
    () => ({
      newNotificationsArr,
      setNewNotificationsArr,
    }), [newNotificationsArr])
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotification() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }
  return context
}